import { render, staticRenderFns } from "./FolderDynamicTopMatter.vue?vue&type=template&id=154cc860"
import script from "./FolderDynamicTopMatter.vue?vue&type=script&lang=ts"
export * from "./FolderDynamicTopMatter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports